import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getPageLinkByPageType, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import updateQuantity from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateQuantity";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer from "@insite/content-library/Components/CardContainer";
import CardList from "@insite/content-library/Components/CardList";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import cancelSubscriptionForm from "@TKCCP/Handler/TkccpCancelSubscriptionHandler";
import getSubscribedProductData from "@TKCCP/Handler/TkccpGetMySuscribedProducts";
import CardListHeading from "@TKCCP/Overrides/Components/CardListHeading";
import CustomApplicationState from "@TKCCP/Store/CustomHandlerCreator/CustomApplicationState";
import parse from "html-react-parser";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    link = "link",
    variant = "variant",
    noProducts = "noProducts",
    numberOfRecords = "numberOfRecords",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.variant]: "primary" | "secondary" | "tertiary";
        [fields.label]: string;
        [fields.link]: LinkFieldValue;
        [fields.noProducts]: string;
        [fields.numberOfRecords]: number;
    };
}
interface OwnProps {
    productInfo: ProductInfo;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        SubscribedProducts: state.tKCCPData.SubscriptionProductStore?.setSubscribedProduct,
        CustomerId: state.context.session.billToId || "",
        UserProfileId: state.context.session.userProfileId || "",
        myListsPageNavLink: getPageLinkByPageType(state, "MySubscriptionPage"),
        isPunchOutSubFlag: state.context.session?.userRoles?.split(", ").some((val)=>{
            return val === "PunchOut";
        }),
    };
};

export interface RecentSubscriptionProductListSytles {
    title: TypographyProps;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    checkbox?: CheckboxPresentationProps;
    subscriptionMainContainer?: GridContainerProps;
    subscriptionGirdItem?: GridItemProps;
    subscriptionSubGridItem?: GridItemProps;
    selectedCheckbox?: CheckboxPresentationProps;
    image?: LazyImageProps;
    StartEndWrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    priceLabelText?: TypographyPresentationProps;
    productLabelText?: ClickablePresentationProps;
    dateText?: TypographyPresentationProps;
    amountLabelText?: TypographyPresentationProps;
    nameWrapper?: InjectableCss;
    yesnoWrapper?: InjectableCss;
    mainWrapper?: InjectableCss;
    quantityWrapper?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    qunaityField?: TextFieldProps;
    cancelButton?: ButtonPresentationProps;
    cancelButtonWrapper?: InjectableCss;
    createListModal?: ModalPresentationProps;
    noSubscriptionText?: TypographyProps;
}

export const RecentSubscriptionProductListSytles: RecentSubscriptionProductListSytles = {
    title: {
        variant: "h2",
        size: "32px",
        css: css`
            margin-bottom: 0rem;
        `,
    },
    titleWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            gap: 150px;
            margin-bottom: 30px;
        `,
    },
    checkboxGroup: {
        css: css`
            align-items: flex-start;
            height: 100%;
            justify-content: center;
        `,
    },
    subscriptionGirdItem: {
        css: css`
            flex-direction: column;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
        `,
    },
    subscriptionSubGridItem: {
        css: css`
            border-top: 1px solid #cecece;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
            padding: 10px 0px;
            margin: 10px 0px !important;
        `,
    },
    StartEndWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            gap: 15px;
        `,
    },
    nameWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            /* margin-left: 30px; */
            /* width: 400px; */
        `,
    },
    mainWrapper: {
        css: css`
            // display: flex;
            // flex-direction: column;
            // border-top: 1px solid grey;
            // padding: 15px;
            /* margin-left: 30px; */
        `,
    },
    productLabelText: {
        css: css`
        color: #0074b9;
        font-weight: 500;
        font-size: 20px;
        `,
    },

    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
            border-top: 2px SOLID BLACK;
        `,
    },
    yesnoWrapper: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
            margin: auto;
            gap: 50px;
            margin-top: 40px;
            justify-content: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    dateText: {
        css: css`
            // margin-left: 30px;
            display: flex;
            flex-direction: row;
            font-size: 14px;
            // gap: 5px;
        `,
    },
    priceLabelText: {
        css: css`
            font-weight: bold;
            color: #7b7b7b;
        `,
    },
    amountLabelText: {
        css: css`
            color: #7b7b7b;
        `,
    },

    quantityWrapper: {
        css: css`
            margin-left: 80px;
        `,
    },

    qunaityField: {
        css: css`
            width: 40px !important;
        `,
    },

    cancelButton: {
        css: css`
            margin-top: 0px;
        `,
    },
    cancelButtonWrapper: {
        css: css`
            /* margin-bottom: 10px;
            margin-top: 15px; */
            display: flex;
            justify-content: end;
            gap: 20px;
            margin-top: 10px;
        `,
    },
    createListModal: {
        closeButtonProps: {
            shape: "rounded",
            buttonType: "solid",
            size: 36,
        },
        closeButtonIconProps: {
            src: "X",
            size: 24,
            color: "#525252",
            css: css`
                svg {
                    color: #525252 !important;
                }
            `,
        },

        cssOverrides: {
            modalBody: css`
                padding: 0px;
                width: 680px;
            `,
            modalTitle: css`
                color: #000;
            `,
            modalContent: css``,
            titleButton: css``,
        },
    },
};

const styles = RecentSubscriptionProductListSytles;

const mapDispatchToProps = {
    updateQuantity,
    getSubscribedProductData,
    cancelSubscriptionForm,
};

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RecentSubscriptionProductList = ({
    productInfo,
    CustomerId,
    UserProfileId,
    getSubscribedProductData,
    SubscribedProducts,
    cancelSubscriptionForm,
    fields,
    myListsPageNavLink,
    isPunchOutSubFlag,
}: Props) => {
    const [subscribedProductList, setSubscribedProductList] = useState(SubscribedProducts);
    if(isPunchOutSubFlag){
        return null;
    }
    const mySubscriptionPageUrl = "MyAccount/MySubscription";
    useEffect(() => {
        getSubscribedProductData({
            CustomerId,
            UserProfileId,
        });
    }, []);

    useEffect(() => {
        if (SubscribedProducts.length > 0) {
            const setAllCheckBoxFalse = SubscribedProducts.map(product => {
                const products = { ...product };
                products.isActive = false;
                return products;
            });
            setSubscribedProductList(setAllCheckBoxFalse);
        }
    }, [SubscribedProducts]);

    const formatDate = (dateString: string | number | Date | undefined) => {
        if (!dateString) {
            return "";
        } // If dateString is undefined, return an empty string
        const date = new Date(dateString);
        return date.toISOString().split("T")[0]; // Extracting date part
    };

    const NumberOfSubscribedProduct = (SubscribedProducts && SubscribedProducts.length > fields.numberOfRecords) ? SubscribedProducts.slice(0, fields.numberOfRecords) : SubscribedProducts;
    return (
        <>
            {NumberOfSubscribedProduct?.length ? (
                <StyledWrapper>
                    <CardList data-test-selector="cardListRecentSubscription">
                        <CardListHeading heading={translate("My Subscription")} viewAllUrl={mySubscriptionPageUrl} />
                        {NumberOfSubscribedProduct && NumberOfSubscribedProduct.length === 0 && (
                            <GridItem width={12}>
                                <Typography {...styles.noSubscriptionText}>
                                    {translate("No Subscription Found")}
                                </Typography>
                            </GridItem>
                        )}
                        {NumberOfSubscribedProduct &&
                            NumberOfSubscribedProduct.map((ProductsSubscribed, index) => (
                                <CardContainer key={`${ProductsSubscribed.name}_${index}`}>
                                    <StyledWrapper {...styles.mainWrapper}>
                                        <StyledWrapper {...styles.StartEndWrapper}>
                                            <Clickable
                                                href={`MyAccount/MySubscription/EditSubscription?id=${ProductsSubscribed.id}`}
                                                {...styles.productLabelText}
                                            >
                                                {ProductsSubscribed.name}
                                            </Clickable>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.dateText}>
                                            <StyledWrapper>
                                                {siteMessage("Created On")} : {formatDate(ProductsSubscribed.createdOn)}
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </CardContainer>
                            ))}
                    </CardList>
                </StyledWrapper>
            ) : (
                ""
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RecentSubscriptionProductList),
    definition: {
        group: "Basic",
        displayName: "Recent Subscribed Product",
        fieldDefinitions: [
            {
                name: fields.numberOfRecords,
                displayName: "Number of Lists Displayed",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 3,
                fieldType: "General",
                sortOrder: 1,
            }
        ],
    },
};

export default widgetModule;
